import { ReactElement } from "react";

export default function IconComputer(): ReactElement {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0C3.67157 0 3 0.671573 3 1.5V4.125C3 4.95343 3.67157 5.625 4.5 5.625H7.125C7.95343 5.625 8.625 4.95343 8.625 4.125V1.5C8.625 0.671573 7.95343 0 7.125 0H4.5ZM5.8125 3.75C6.33027 3.75 6.75 3.33027 6.75 2.8125C6.75 2.29473 6.33027 1.875 5.8125 1.875C5.29473 1.875 4.875 2.29473 4.875 2.8125C4.875 3.33027 5.29473 3.75 5.8125 3.75Z"
        fill="#5A6072"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 6.375C0.671573 6.375 0 7.04657 0 7.875V10.5C0 11.3284 0.671573 12 1.5 12H4.125C4.95343 12 5.625 11.3284 5.625 10.5V7.875C5.625 7.04657 4.95343 6.375 4.125 6.375H1.5ZM2.8125 10.125C3.33027 10.125 3.75 9.70527 3.75 9.1875C3.75 8.66973 3.33027 8.25 2.8125 8.25C2.29473 8.25 1.875 8.66973 1.875 9.1875C1.875 9.70527 2.29473 10.125 2.8125 10.125Z"
        fill="#5A6072"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.375 7.875C6.375 7.04657 7.04657 6.375 7.875 6.375H10.5C11.3284 6.375 12 7.04657 12 7.875V10.5C12 11.3284 11.3284 12 10.5 12H7.875C7.04657 12 6.375 11.3284 6.375 10.5V7.875ZM10.125 9.1875C10.125 9.70527 9.70527 10.125 9.1875 10.125C8.66973 10.125 8.25 9.70527 8.25 9.1875C8.25 8.66973 8.66973 8.25 9.1875 8.25C9.70527 8.25 10.125 8.66973 10.125 9.1875Z"
        fill="#5A6072"
      />
    </svg>
  );
}
